module.exports = __webpack_public_path__ + "img/icon-card-2.75bcaf23.webp";